'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SendIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SendIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2354_1897)">
          <path d="M17.625 0.375L6.75 11.25Z" fill="white" />
          <path d="M17.625 0.375L6.75 11.25" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M10.125 17.625L6.75 11.25L0.375 7.875L17.625 0.375L10.125 17.625Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2354_1897">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

SendIcon.propTypes = {
  sx: PropTypes.object
}
